import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-bank-token-error-helper-dialog',
    template: require('./bankTokenError.html'),
})
export class BankTokenErrorHelperDialog {

    constructor(@Inject(MatDialogRef<BankTokenErrorHelperDialog>) public dialogRef: MatDialogRef<BankTokenErrorHelperDialog>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }

}
